import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from '../../../core/services/config.service';
import { MenuItemBaseComponent } from '../../restaurant/restaurant-menu/menu-item-base/menu-item-base.component';
import { MenuItemControlButtonComponent } from "../../restaurant/restaurant-menu/menu-item/menu-item-control-button/menu-item-control-button.component";
import { PricePipe } from "../../../core/pipes/price.pipe";
import { ReadMoreComponent } from "../../../common/read-more/read-more.component";
import { ItemWithOptionUpdateComponent } from "../../restaurant/restaurant-menu/item-with-option-update/item-with-option-update.component";
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { TranslocoService } from '@jsverse/transloco';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-menu-item-v2',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.css'],
    standalone: true,
    imports: [
        NgbTooltipModule,
        TranslocoCurrencyPipe,
        PricePipe,
        MenuItemControlButtonComponent,
        ReadMoreComponent,
        ItemWithOptionUpdateComponent]
})
export class MenuItemComponent extends MenuItemBaseComponent implements OnInit {

    @Input() borderRadius: string
    @Input() restaurantCssClass: string = ''
    @Input() font: string
    @Input() image: string
    @Input() descriptionFontWeight: string
    @Input() descriptionColor: string
    @Input() showReadMoreText: boolean = true;
    @Input() showDescription: boolean = false

    constructor(public translate: TranslocoService, public configService: ConfigService) {
        super(translate, configService)
    }

    ngOnInit(): void {
        super.ngOnInit()
    }

}
